import { Code, ConnectError } from "@connectrpc/connect";
import { extractConnectErrorMessage } from "../../libs/connect";
import { t } from "../../libs/i18n";

export function getChargeErrorMessage(
  error: unknown,
  fallbackMessage: string,
): string {
  if (error instanceof ConnectError) {
    if (error.code === Code.PermissionDenied) {
      return `${fallbackMessage}\n${getPermissionDeniedChargeMessage(error)}`;
    }

    return `${fallbackMessage}\n${extractConnectErrorMessage(error)}`;
  }

  if (error instanceof Error) {
    return `${fallbackMessage}\n[${error.message}]`;
  }

  return fallbackMessage;
}

function getPermissionDeniedChargeMessage(error: ConnectError): string {
  const message = `${error.rawMessage}\n${error.message}`;

  if (message.includes("charge campaign is not active")) {
    return t("現在はチャージ期間外です。購入期間中に再度お試しください。");
  }

  if (
    message.includes("not the campaign winner") ||
    message.includes("already over max")
  ) {
    return t(
      "チャージできる口数がありません。購入期間や購入済み口数を確認してください。",
    );
  }

  return t(
    "現在はチャージできません。購入期間や購入可能口数を確認してください。",
  );
}
